import { FC } from 'react';

import { Form } from '@customTypes/Entities';
import { check, uncheck, checkAll, uncheckAll, getSelectedForms, getFormsQuery, setQuery } from '@features/formsSlice';
import useForms from '@hooks/useForms';
import { ROUTES } from '@routes/constants';
import { useAppDispatch } from '@store';
import { DateTime } from 'luxon';
import { useSelector } from 'react-redux';

import ErrorBox from '@components/ErrorBox';
import TranslationStatusBadge from '@components/TranslationStatusBadge';

import EntityMainLayout, { ColumnSortFunction } from '../../layouts/EntityMainLayout';
import NameField from '../../layouts/EntityMainLayout/NameField';
import { sortDates, sortNumbers, sortStrings } from '../../utils/sorters';

const Forms: FC = () => {
  const selected = useSelector(getSelectedForms);
  const query = useSelector(getFormsQuery);

  const dispatch = useAppDispatch();

  const { forms, isFetching: loadingForms, error, refetchAll } = useForms();

  return (
    <EntityMainLayout<Form>
      error={!!error}
      errorComponent={<ErrorBox message={error ? error.message : ''} clear={() => refetchAll()} />}
      entities={forms}
      loadingEntities={loadingForms}
      selected={selected}
      searchProps={{ query, setQuery: (query) => dispatch(setQuery(query)) }}
      columns={[
        {
          key: 'id',
          header: 'ID',
          sort: sortNumbers as ColumnSortFunction,
          style: { maxWidth: '100px', minWidth: '100px' },
        },
        {
          key: 'name',
          header: 'Form name',
          sort: sortStrings as ColumnSortFunction,
          render: (row) => <NameField name={row.name} url={row.url} description={row.description} />,
          style: { minWidth: '450px', width: '100%' },
        },
        {
          key: 'translationStatus',
          header: 'Translation Status',
          sort: sortStrings as ColumnSortFunction,
          render: (row) =>
            row.translationStatus ? (
              <div style={{ margin: 'auto' }}>
                <TranslationStatusBadge status={row.translationStatus} />
              </div>
            ) : (
              ''
            ),
          style: { width: '200px', minWidth: '200px' },
        },
        {
          key: 'updatedAt',
          header: 'Last modified at',
          sort: sortDates as ColumnSortFunction,
          render: ({ updatedAt }) => DateTime.fromISO(updatedAt.split('Z')[0]).toLocaleString(DateTime.DATETIME_SHORT, { locale: window.navigator.language }),
          style: { width: '200px', minWidth: '200px' },
        },
      ]}
      title={'Forms'}
      check={(row) => dispatch(check(row))}
      uncheck={(id) => dispatch(uncheck(id))}
      checkAll={(rows) => dispatch(checkAll(rows))}
      uncheckAll={() => dispatch(uncheckAll())}
      newOrderRoute={ROUTES.ORDERS_FORM}
    />
  );
};

export default Forms;
